import React from "react";
import "./Github.css";

const Github = () => {
    return (
        <div className="github-container">
            <h2 className="section-title" style={{
                fontSize: "2rem",
                marginTop: "2rem",
                marginBottom: "2rem",
                color: "rgb(5, 127, 255)",
                textAlign: "center"
            }}>GitHub Stats</h2>
            <div className="github-stats">
                <div>
                    <img
                        className="github-stats-img"
                        src="https://github-readme-stats.vercel.app/api?username=ahsanofficial&show_icons=true&theme=radical"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="github-stats-img"
                        src="https://github-readme-streak-stats.herokuapp.com?user=ahsanofficial&theme=react&hide_border=true)](https://git.io/streak-stats"
                        alt=""
                    />
                </div>
            </div>
            <h2 className="github_heading" style={{
                fontSize: "2rem",
                marginTop: "3rem",
                marginBottom: "4rem",
                color: "rgb(5, 127, 255)",
                textAlign: "center"
            }}>DAYS I CODE</h2>
        </div >
    );
};
export default Github;